import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'This field is required.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },  
    notes: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Contact Form',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'All fields except Phone are required.',
            mapping: 'headerLabel',
            customClasses: ['sub-header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'First Name:',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Large',
            mapping: 'firstName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Last Name:',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Large',
            mapping: 'lastName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Email:',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Large',
            mapping: 'email',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Phone:',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Large',
            mapping: 'telNumber',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Content:',
            mapping: 'headerLabel'
          },
          {
            type: 'text-area',
            size: 'Large',
            mapping: 'notes',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Content:',
            mapping: 'headerLabel',
            customClasses: ['no-label']
          },
          {
            type: 'submit',
            size: 'Large',
            label: 'Send Email'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Thomas Meat and Seafood Contact Form',
    formId: '171',
    clientKey: '3907878A-6653-415E-9760-522CD42AE1BE',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/web_inquiry/inquiry-renderer/client_forms/thomasmeatseafood/form_structure.js